import { Anchor, Heading, Paragraph } from '@zillow/constellation';

const ACCOUNT_VERIFICATION_EMAIL = 'account_verification@zillow.com';

export const RenterBlockedUser = () => {
  return (
    <div className="BlockedUserComponent">
      <Heading level="5" marginBottom="md">
        Your account is currently disabled
      </Heading>
      <Paragraph marginBottom="md">
        We are unable to access your properties at this time. Please contact{' '}
        <Anchor href={`mailto:${ACCOUNT_VERIFICATION_EMAIL}`}>{ACCOUNT_VERIFICATION_EMAIL}</Anchor> to resolve the
        issue.
      </Paragraph>
      <Paragraph>
        Return to <Anchor href="https://www.zillow.com">Zillow</Anchor>
      </Paragraph>
    </div>
  );
};
